export default __webpack_public_path__ + "static/media/Mujer_E-Hunter.afe8e5be.png";